export default {
	title: 'Manažer',
	subheader: 'Obchodníci v kampani',
	contacts: 'Kontakty manažera',
	seller: 'Obchodník',
	client: 'Klient',
	birthDate: 'Datum narození',
	phone: 'Telefon',
	product: 'Produkt',
	policyNo: 'Číslo PS',
	policyAdmin: 'Správce smlouvy',
	state: 'Stav',
	note: 'Poznámka',
	policyFinishDate: 'Datum konce smlouvy',
};
